import React from 'react';
import { motion } from 'framer-motion';
import { Mail, MessageCircle } from 'lucide-react';
interface PriceBlockProps {
  compact?: boolean;
  darkMode?: boolean;
}
export function PriceBlock({
  compact = false,
  darkMode = false
}: PriceBlockProps) {
  const subtextColor = darkMode ? 'text-cream-alt/70' : 'text-brown-light/70';
  const borderColor = darkMode ? 'border-cream-alt/15' : 'border-brown/10';
  const deliveryTextColor = darkMode ? 'text-cream-alt/60' : 'text-brown-light/60';
  if (compact) {
    return <div className="flex flex-col items-center gap-4 my-6" data-id="element-119">
        <div className="flex items-baseline gap-1" data-id="element-120">
          <span className={`font-['DM_Sans',_sans-serif] text-[22px] tracking-wide ${subtextColor} line-through decoration-1 font-medium`} data-id="element-121">
            $30.000
          </span>
          <span className={`mx-2 ${subtextColor}`} data-id="element-122">→</span>
          <span className="text-4xl md:text-5xl tracking-tight text-gold-end leading-none font-[800] font-['DM_Sans',_sans-serif]" data-id="element-123">
            <span className="text-2xl md:text-3xl align-top" data-id="element-124">$</span>13.990
          </span>
        </div>
        <div className={`flex items-center gap-2 text-xs tracking-wide uppercase ${deliveryTextColor}`} data-id="element-125">
          <Mail className="w-3.5 h-3.5 text-gold-end/70" data-id="element-126" />
          <span className="font-inter font-medium" data-id="element-127">
            Entrega inmediata · Correo y WhatsApp
          </span>
        </div>
      </div>;
  }
  return <motion.div initial={{
    opacity: 0,
    y: 15
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5
  }} className="flex flex-col items-center my-10" data-id="element-128">
      {/* Price card */}
      <div className="flex flex-col items-center gap-5" data-id="element-129">
        {/* Original price section */}
        <div className="flex flex-col items-center gap-1" data-id="element-130">
          <span className={`font-inter text-sm md:text-base tracking-wide ${subtextColor}`} data-id="element-131">
            Valor total del programa:
          </span>
          <span className={`font-['DM_Sans',_sans-serif] text-3xl md:text-4xl font-semibold ${subtextColor} line-through decoration-2`} data-id="element-132">
            $39.990
          </span>
        </div>

        {/* Special price label */}
        <span className={`font-inter text-sm md:text-base tracking-wide ${subtextColor}`} data-id="element-133">
          Precio especial por tiempo limitado:
        </span>

        {/* Main price in gold box */}
        <div className="relative w-full max-w-xs md:max-w-sm rounded-lg px-8 md:px-12 py-5 md:py-6 flex items-center justify-center border-2 border-yellow-700/30" style={{
        background: 'linear-gradient(135deg, #c9a84c 0%, #d4b85a 50%, #b8943f 100%)'
      }} data-id="element-134">
          <span className="font-['DM_Sans',_sans-serif] text-5xl md:text-7xl font-[900] tracking-tight text-brown leading-none" data-id="element-135">
            $13.990
          </span>
        </div>

        {/* Savings callout */}
        <span className="font-['DM_Sans',_sans-serif] text-lg md:text-xl font-[800] tracking-wide text-gold-end uppercase" data-id="element-136">
          ¡AHORRAS $26.000 HOY!
        </span>

        {/* Subtitle */}
        <span className={`font-inter text-[11px] uppercase tracking-[0.2em] ${subtextColor}`} data-id="element-137">
          Pago único · Acceso de por vida
        </span>

        {/* Delivery info */}
        <div className={`flex flex-col sm:flex-row items-center gap-3 sm:gap-5 mt-2 ${deliveryTextColor}`} data-id="element-138">
          <div className="flex items-center gap-2" data-id="element-139">
            <Mail className="w-3.5 h-3.5 text-gold-end/60" data-id="element-140" />
            <span className="font-inter text-xs tracking-wide" data-id="element-141">
              Recíbelo al instante en tu correo
            </span>
          </div>
          <div className={`hidden sm:block w-px h-3 ${darkMode ? 'bg-cream-alt/20' : 'bg-brown/15'}`} data-id="element-142"></div>
          <div className="flex items-center gap-2" data-id="element-143">
            <MessageCircle className="w-3.5 h-3.5 text-gold-end/60" data-id="element-144" />
            <span className="font-inter text-xs tracking-wide" data-id="element-145">
              También por WhatsApp
            </span>
          </div>
        </div>
      </div>
    </motion.div>;
}